<template>
  <div>
    <div class="saasBox">
      <div class="softMarketTop">
        <div class="softMarketTopSearch">
          <div class="logoTitle">
            <div class="logoTitle1">
              软件超市
            </div>
            <div class="logoTitle2">应用分类</div>
          </div>
          <div class="searchContainer">
            <div class="flex searchContainerone" @keyup.enter="getSassOne()">
              <el-input
                placeholder="在此输入你需要的服务"
                v-model="searchInputValue"
                class="input-with-select"
                prefix-icon="el-icon-search"
              >
                <el-button slot="append" @click="getSassOne()">
                  搜索
                </el-button>
              </el-input>
            </div>

            <ul>
              <li
                class="textLi"
                v-for="(dictionary, index) in hotSearch"
                :key="index"
                @click="findHotSearch(dictionary.name)"
              >
                {{ dictionary.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="softMarketBanner">
        <div class="bannerContainer">
          <div class="bannerContainerLeft">
            <div class="softMarketClassifyContainer">
              <ul>
                <li v-for="(item, index) in bannerTextList">
                  <span
                    :class="textListIndex == index ? 'typeName' : 'typeName2'"
                    @click="getSassList('', item.uuid, index)"
                    @mouseenter="getSoftwareByType(item.uuid)"
                    >{{ item.typeName }}</span
                  >
                  <p style="display: flex; flex-wrap: wrap; width: 167px">
                    <span
                      v-for="child in item.bannerTextChildrenList"
                      class="itemName"
                      @click="goToVeiws(child.uuid)"
                      @mouseenter="getSoftwareByType(item.uuid)"
                      >{{ child.softwareName }}</span
                    >
                  </p>
                  <div class="softMarketClassifyPanel">
                    <div class="panelContainer">
                      <div
                        v-for="item in softwareByTypeList"
                        class="panelItem"
                        @click="goToVeiws(item.uuid)"
                      >
                        <img :src="item.softwareLogo" alt="" />
                        <p>{{ item.softwareName }}</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="bannerContainerCenter">
            <div class="bannerContainerTop">
              <el-carousel trigger="click" height="280px">
                <el-carousel-item v-for="item in bannerList" :key="item.uuid">
                  <img
                    :src="item.value"
                    @click="getBannerListTop(item)"
                    alt=""
                    style="width: 910px; height: 280px; display: block;cursor: pointer;"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="bannerContainerBottom">
              <!-- <el-carousel trigger="click" height="90px" width="897px" direction="vertical">
                <el-carousel-item v-for="item in advertisementList" :key="item.uuid">
                  <img
                    :src="item.value"
                    @click="getBannerListTop(item)"
                    alt=""
                    style="width: 897px; height: 90px; display: block;cursor: pointer;"
                  />
                </el-carousel-item>
              </el-carousel> -->
              <a
                :href="item.linkUrl ? item.linkUrl : 'javascript:void(0);'"
                :target="item.linkUrl ? '_blank' : '_self'"
                v-for="item in advertisementList"
                :key="item.uuid"
                ><img :src="item.value" alt=""
              /></a>
              <div class="bannerContainerBottomimg"></div>
              <div class="bannerContainerBottomimg"></div>
              <div class="bannerContainerBottomimg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <section style="margin-bottom: 15px;margin-top: 18spx;">
        <h2 class="printTitle">
          <span class="tit">精品软件</span
          ><span class="more" @click="getSassOne('BOUTIQUE')">查看更多 > </span>
        </h2>

        <el-row :gutter="30" class="content">
          <el-col
            :span="4"
            v-for="(items, index) in boutiqueSoftwareList"
            :key="index"
          >
            <el-card
              class="box-card"
              shadow="hover"
              :body-style="{ padding: '0px', 'text-align': 'center' }"
            >
              <el-image
                class="image"
                @click="goToVeiws(items.uuid)"
                style="cursor: pointer"
                :src="items.softwareLogo"
                fit="fill"
              ></el-image>
              <div style="padding: 15px">
                <h2
                  @click="goToVeiws(items.uuid)"
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    cursor: pointer;
                  "
                >
                  {{ items.softwareName }}
                </h2>
                <p
                  style="
                    color: #505050;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                  {{ items.supplierName }}
                </p>
                <p
                  class="sDetail"
                  @click="goToVeiws(items.uuid)"
                  style="cursor: pointer"
                  :title="items.description"
                >
                  {{ items.description }}
                </p>
                <p class="sPrice" v-if="items.canBuy == 0">
                  暂无价格
                </p>
                <div v-else>
                  <p
                    class="sPrice"
                    v-if="items.price == null || items.price == undefined"
                  >
                    <span>¥</span>未定价
                  </p>
                  <p
                    class="sPrice"
                    v-if="items.price != null && items.price != undefined"
                  >
                    <span>¥</span
                    >{{ number_format(items.price, 2, ".", ",") }}/{{
                      items.billingModeUnit
                    }}
                  </p>
                </div>
                <div class="mpFooter">
                  <span
                    ><i class="el-icon-view" style="margin-right: 8px"></i
                    >{{ items.pageViews }}</span
                  >
                  <span
                    ><i class="el-icon-star-off" style="margin-right: 8px"></i
                    >{{ items.collectionsNum }}</span
                  >
                  <span
                    ><i
                      class="el-icon-chat-line-square"
                      style="margin-right: 8px"
                    ></i
                    >{{ items.commentNum }}</span
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </section>
    </div>
    <div class="container">
      <section style="margin-bottom: 15px">
        <h2 class="printTitle">
          <span class="tit">最新上线</span
          ><span class="more" @click="getSassOne('NEW')">查看更多 > </span>
        </h2>
        <el-row :gutter="30" class="content">
          <el-col
            :span="4"
            v-for="(items, index) in newSoftwareList"
            :key="index"
          >
            <el-card
              class="box-card"
              shadow="hover"
              :body-style="{ padding: '0px', 'text-align': 'center' }"
            >
              <el-image
                class="image"
                @click="goToVeiws(items.uuid)"
                style="cursor: pointer"
                :src="items.softwareLogo"
                fit="fill"
              ></el-image>
              <div style="padding: 15px">
                <h2
                  @click="goToVeiws(items.uuid)"
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    cursor: pointer;
                  "
                >
                  {{ items.softwareName }}
                </h2>
                <p
                  style="
                    color: #505050;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                  {{ items.supplierName }}
                </p>
                <p
                  class="sDetail"
                  @click="goToVeiws(items.uuid)"
                  style="cursor: pointer"
                  :title="items.description"
                >
                  {{ items.description }}
                </p>

                <p class="sPrice" v-if="items.canBuy == 0">
                  暂无价格
                </p>
                <div v-else>
                  <p
                    class="sPrice"
                    v-if="items.price == null || items.price == undefined"
                  >
                    <span>¥</span>未定价
                  </p>
                  <p
                    class="sPrice"
                    v-if="items.price != null && items.price != undefined"
                  >
                    <span>¥</span
                    >{{ number_format(items.price, 2, ".", ",") }}/{{
                      items.billingModeUnit
                    }}
                  </p>
                </div>
                <div class="mpFooter">
                  <span
                    ><i class="el-icon-view" style="margin-right: 8px"></i
                    >{{ items.pageViews }}</span
                  >
                  <span
                    ><i class="el-icon-star-off" style="margin-right: 8px"></i
                    >{{ items.collectionsNum }}</span
                  >
                  <span
                    ><i
                      class="el-icon-chat-line-square"
                      style="margin-right: 8px"
                    ></i
                    >{{ items.commentNum }}</span
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </section>
    </div>
    <div class="container">
      <section style="margin-bottom: 15px">
        <h2 class="printTitle" style="margin-bottom: 20px;">
          <span class="tit">软件供应商</span>
        </h2>
        <el-row :gutter="30">
          <el-col
            :span="4"
            style="margin-bottom: 20px"
            v-for="(items, index) in softwareSupplierList"
            :key="index"
          >
            <el-image
              style="
                width: 180px;
                height: 90px;
                box-shadow: 0px 0px 5px 2px #efefef;
              "
              :src="items.logoUrl"
            >
            </el-image>
          </el-col>
        </el-row>
      </section>
    </div>
  </div>
</template>

<script>
import {
  getBannerList,
  getSoftwareTypeList,
  getSoftwareList,
  getSoftwareSupplierList,
  getNewcurrent,
  getIndexDictionaryData,
} from "../../utils/interface"
import { mapState } from "vuex"

export default {
  //   软件超市
  name: "saas",
  metaInfo: {
    title:
      "软件超市 - 为水泵行业企业提供信息化产品软件服务-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台 | 信息化软件 | 智能制造解决方案| 水泵数字化| saas平台 | 平台软件服务 | 企业数字化服务| 企业管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台软件超市提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      textListIndex: null,
      hotSearch: [],
      softwareByTypeList: [],
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "soft_banner",
      bannerList: [],
      boutiqueList: [],
      newSoftwareList: [],
      serviceLogo: [],
      boutiqueSoftwareList: [],
      bannerTextList: [],
      bannerListShow: false,
      advertisementList: [],
      setIn: null,
      searchInputValue: "",
      softwareSupplierList: [],
      userDetail: {},
      targetMess: "_blank",
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn)
        this.getBannerList()
      }
    }, 500)
    if (this.$store.state.isLogin) {
      this.getNewcurrent()
    } else {
      this.getBoutiqueSoftwareList()
      this.getNewSoftwareList()
    }
    this.getSoftwareSupplierList()
    this.getSoftwareTypeList()
    this.getHostSearch()
    this.getAdvertisementList()
  },
  mounted() {
    /* console.log(this.bannerList.length !== 0)
             if (this.bannerList.length !== 0) {
                 window.addEventListener("resize", () => {
                     this.imgHeight = this.$refs.image[0].height;
                 });
             }*/
  },
  methods: {
    getBannerListTop(items) {
      if (items.linkUrl) {
        window.open(items.linkUrl, "_blank")
      } else {
        console.log("无链接")
      }
    },
    handTextlist(i) {
      this.textListIndex = i
    },
    handTextlistnone() {
      this.textListIndex = ""
    },
    findHotSearch(searchName) {
      this.searchInputValue = searchName
      this.getSassOne()
    },

    getHostSearch() {
      getIndexDictionaryData({
        groupCode: "RJRS",
      })
        .then((response) => {
          console.log(response, "yuioop")
          this.hotSearch = response
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    getNewcurrent() {
      if (!this.$store.state.isLogin) {
        return
      }
      getNewcurrent().then((res) => {
        this.userDetail = res
        this.getBoutiqueSoftwareList()
        this.getNewSoftwareList()
      })
    },
    getBannerList() {
      let params = {
        groupCode: this.groupCode,
      }
      getBannerList(params).then((res) => {
        if (res.length !== 0) {
          this.bannerList = res
        }
      })
    },
    getAdvertisementList() {
      let params = {
        groupCode: "SOFTWARE_ADVERTISEMENT",
      }
      getBannerList(params).then((res) => {
        if (res.length !== 0) {
          this.advertisementList = res
        }
      })
    },
    getSoftwareByType(uuid) {
      this.bannerListShow = true
      let param1 = {
        current: 1,
        pageSize: 18,
        state: 1251,
        softwareType: uuid,
      }
      getSoftwareList(param1).then((res) => {
        this.softwareByTypeList = res.list
        // console.log(this.softwareByTypeList)
      })
    },

    getSoftwareSupplierList() {
      let param1 = {
        current: 1,
        pageSize: 24,
      }
      getSoftwareSupplierList(param1).then((res) => {
        this.softwareSupplierList = res.list
      })
    },

    getSoftwareTypeList() {
      let params = {
        current: 1,
        pageSize: 9,
      }
      getSoftwareTypeList(params).then((res) => {
        if (res.list.length > 0) {
          this.bannerTextList = res.list
          console.log(this.bannerTextList)
          this.bannerTextList.map((item) => {
            let param1 = {
              current: 1,
              pageSize: 18,
              state: 1251,
              softwareType: item.uuid,
            }
            getSoftwareList(param1).then((res) => {
              this.$set(item, "bannerTextChildrenList", res.list)
            })
          })
        } else {
          this.bannerTextList = []
        }
      })
    },
    getSassOne(tabParam) {
      if (tabParam == null) {
        tabParam = "NEW"
      }
      let routeData = this.$router.resolve({
        path: "/appsList",
        query: {
          tabParam: tabParam,
          search: this.searchInputValue,
        },
      })
      this.searchInputValue = ""
      window.open(routeData.href, "_blank")
    },
    getSassList(tabParam, typeUuid, severmessIndex) {
      tabParam = "NEW"
      let routeData = this.$router.resolve({
        path: "/appsList",
        query: {
          tabParam: tabParam,
          search: this.searchInputValue,
          typeUuid: typeUuid,
          severmessIndex: severmessIndex,
        },
      })
      window.open(routeData.href, "_blank")
    },
    imgLoad() {
      this.$nextTick(function() {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            this.imgHeight = this.$refs.image[0].height
            // console.log(5555, this.imgHeight);
          } else {
            clearInterval(this.imgHeightsetIn)
            // console.log(6666, this.imgHeight);
          }
        }, 520)
      })
    },
    getBoutiqueSoftwareList() {
      let param1 = {
        current: 1,
        pageSize: 10,
        state: 1251,
        isRecommend: true,
        sort: "RECOMMEND_SORT",
        userId: this.userDetail.uuid,
      }
      getSoftwareList(param1).then((res) => {
        console.log(res)
        this.boutiqueSoftwareList = res.list
      })
    },
    getNewSoftwareList() {
      let param1 = {
        current: 1,
        pageSize: 10,
        state: 1251,
        sort: "PUT_DATE",
        userId: this.userDetail.uuid,
      }

      getSoftwareList(param1).then((res) => {
        this.newSoftwareList = res.list
      })
    },
    goToVeiws(uuid) {
      let routeData = this.$router.resolve({
        name: "saasDetails",
        params: { uuid: uuid },
        query: {
          titleName: "软件超市",
          titleIndex: "index",
        },
      })
      window.open(routeData.href, "_blank")
    },
    number_format(number, decimals, dec_point, thousands_sep) {
      /*
       * 参数说明：
       * number：要格式化的数字
       * decimals：保留几位小数
       * dec_point：小数点符号
       * thousands_sep：千分位符号
       * */
      number = (number + "").replace(/[^0-9+-Ee.]/g, "")
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function(n, prec) {
          var k = Math.pow(10, prec)
          return "" + Math.ceil(n * k) / k
        }

      s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".")
      var re = /(-?\d+)(\d{3})/
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2")
      }

      if ((s[1] || "").length < prec) {
        s[1] = s[1] || ""
        s[1] += new Array(prec - s[1].length + 1).join("0")
      }
      return s.join(dec)
    },
  },
}
</script>

<style scoped lang="less">
.topSearchTitle {
  padding: 4px 6px;

  &:hover {
    cursor: pointer;
    color: #009999;
  }
}

.softMarketTop {
  width: 100%;
  // height: 110px;
  box-sizing: border-box;

  .softMarketTopSearch {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    padding-top: 18px;
    box-sizing: border-box;

    .logoTitle {
      font-size: 18px;
      // line-height: 74px;
      color: #009999;
      font-weight: bold;

      .logoTitle1 {
        height: 40px;
        font-size: 24px;
        color: #000;
      }

      .logoTitle2 {
        background: #535353;
        height: 40px;
        color: #fff;
        line-height: 40px;
        width: 293px;
        padding-left: 20px;
        box-sizing: border-box;
        margin-top: 10px;
      }
    }

    .searchContainer {
      // width: 690px;
      margin: 0 auto;
      padding: 0 15px;

      .searchContainerone {
        .input-with-select {
          flex-shrink: 0;
        }

        .searchContainerButton {
          color: #009999;
          margin-left: 15px;
          border: 1px solid #009999;
          width: 88px;
          background: #fff;
          font-size: 14px;
          border-radius: 10px;
        }
      }

      /deep/ .input-with-select .el-input__inner {
        border: 1px solid #009999;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        background: #fdfdfd;
        height: 40px;
        line-height: 40px;
      }

      /deep/ .el-input-group {
        height: 40px;
        width: 618px;
      }

      /deep/ .input-with-select .el-input-group__append {
        background: #009999;
        color: #fff;
        border: 1px solid #009999;
        border-left: none;
        border-radius: 0px 20px 20px 0px;
        width: 80px;
        box-sizing: border-box;
        text-align: center;
      }

      ul {
        display: flex;
        color: #6e6e6e;
        padding-left: 3px;

        li {
          font-size: 12px;
          margin-top: 10px;
          padding: 0 15px;

          &.textLi {
            cursor: pointer;
            border-right: 1px solid #979797;

            &:hover {
              color: #009999;
            }
          }
          &.textLi:last-child {
            border: none !important;
          }
        }
      }
    }
  }
}
.saasBox {
  background: url("../../assets/image/BannerBg.png") no-repeat center center;
  background-size: cover;
}
.softMarketBanner {
  width: 100%;
  height: 414px;
  background: url("../../assets/image/BannerBg.png") no-repeat center center;
  background-size: cover;
  .bannerContainer {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .bannerContainerLeft {
      width: 293px;
      position: relative;
      box-sizing: border-box;

      .softMarketClassifyTop {
        width: 100%;
        color: #fff;
        background: #063975;
        height: 50px;
        padding: 0 15px;
        line-height: 50px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
      }

      .softMarketClassifyContainer {
        width: 293px;
        height: 414px;

        ul {
          width: 100%;
          height: 414px;
          position: relative;
          background: #fff;
          padding-top: 16px;
          box-sizing: border-box;

          li {
            padding: 0 18px;
            height: 41px;
            line-height: 44px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: flex;
            .typeName {
              font-size: 14px;
              color: #009999;
              padding-right: 12px;
            }

            .typeName2 {
              font-size: 14px;
              padding-right: 12px;
              display: inline-block;
              min-width: 78px;
              font-weight: bold;
            }

            .itemName {
              color: #3e3e3e;
              font-size: 14px;
              padding-right: 5px;
              display: block;
            }

            span {
              cursor: pointer;

              &:hover {
                color: #009999;
              }
            }

            &:hover {
              .softMarketClassifyPanel {
                display: block;
              }
            }
          }

          .softMarketClassifyPanel {
            position: absolute;
            left: 293px;
            top: 0;
            width: 920px;
            height: 414px;
            background: #f4f4f4;
            z-index: 999;
            display: none;

            .panelContainer {
              display: flex;
              flex-wrap: wrap;

              .panelItem {
                background: #f4f4f4;
                width: 110px;
                margin: 18px 13px 10px;
                text-align: center;
                cursor: pointer;

                img {
                  width: 50px;
                }

                p {
                  color: #858993;
                  line-height: 16px;
                  font-size: 14px;
                  white-space: normal;
                  &:hover {
                    color: #009999;
                  }
                }
              }
            }
          }
        }
      }
    }

    .bannerContainerCenter {
      width: 897px;
      padding: 14px 0;
      box-sizing: border-box;

      /deep/ .el-carousel__indicator {
        button {
          opacity: 1;
          background: #fff;

          &:hover {
            background: #f00;
          }
        }

        &.is-active {
          button {
            background: #f00;
          }
        }
      }
      /deep/.el-carousel__indicator.is-active button {
        background: #009999;
      }

      .bannerContainerBottom {
        display: flex;
        padding-top: 8px;
        justify-content: space-between;
        flex-wrap: wrap;
        // a{
        //   display: inline-block;
        //   width: 100%;
        // }
        img {
          width: 220px;
          height: 90px;
          // object-fit:fill;
        }
        .bannerContainerBottomimg {
          width: 218px;
          height: 0;
        }
        /deep/.el-carousel__indicators--vertical {
          right: 50%;
          bottom: -15px;
          transform: translate(50%, 0);
          display: flex;
          align-items: center;
        }
        /deep/.el-carousel__indicator--vertical .el-carousel__button {
          width: 15px;
          height: 2px;
        }
      }
    }

    .box-card {
      border: 1px solid #e3e3e3;
      font-size: 12px;
      h2 {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .sDetail {
        font-size: 12px;
        margin: 15px auto;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        color: #858993;
      }

      .sPrice {
        font-size: 16px;
        color: #da251d;
        margin-bottom: 15px;

        span {
          font-size: 12px;
        }
      }

      .image {
        width: 64px;
        height: 64px;
        margin-top: 15px;
      }
    }
  }
}

.printBanner {
  position: relative;

  .bannerText {
    position: absolute;
    flex-direction: column;
    top: 0;
    left: 20%;
    z-index: 99;
    color: #fff;
    height: 100%;
    background: rgba(0, 0, 0, 0.324);
    padding: 0 60px;
    align-items: center;
    justify-content: center;

    .bannerTextP {
      margin: 12px 0;
      padding: 0 10px;
      cursor: pointer;
    }

    .bannerTextP:hover {
      color: #009999;
      border-left: 2px solid #158efb;
      padding-left: 8px;
    }
  }

  .bannerTextMess {
    position: absolute;
    top: 10%;
    left: 100%;
    background: rgba(233, 233, 233, 0.66);
    width: 600px;
    z-index: 99;
    height: 300px;
    flex-wrap: wrap;
    padding: 15px;
    text-align: center;

    .bannerTextMess_img {
      margin-bottom: 15px;
      width: 100px;
      height: 90px;

      img {
        width: 64px;
        height: 64px;
      }

      p {
        font-size: 14px;
        color: #fff;
      }
    }
  }
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.printTitle {
  font-size: 18px;
  font-weight: normal;
  margin-top: 20px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;

  span.tit {
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #009999;
  }

  span.more {
    color: #000000;
    cursor: pointer;
    font-size: 12px;
    float: right;
    margin-top: 10px;
    &:hover {
      color: #009999;
    }
  }

  .more i {
    color: #505050 !important;
  }
}

.content {
  /deep/ .el-col-4 {
    width: 20%;
  }
}

.box-card {
  border: 1px solid #e3e3e3;
  font-size: 12px;
  height: 301px;
  margin-top: 20px;
  h2 {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .sDetail {
    font-size: 14px;
    margin: 15px auto;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    // max-height: 57px;
    height: 57px;
    color: #a8a6a6;
  }

  .sPrice {
    font-size: 16px;
    color: #da251d;
    margin-bottom: 15px;

    span {
      font-size: 12px;
    }
  }

  .image {
    width: 64px;
    height: 64px;
    margin-top: 15px;
  }
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ebeef5;
  margin: 0 -21px -15px;
  padding: 10px 20px;

  a {
    color: #505050;
  }
}
</style>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/saas/index.vue